/* Start of Selection */
import $ from 'jquery';

$(document).ready(function() {

(() => {
  // helper – returns nesting depth inside the container
  const depthFromContainer = (el, container) => {
    let d = 0, p = el.parentElement;
    while (p && p !== container) { d++; p = p.parentElement; }
    return d;
  };

  const container = document.querySelector('.shortz .content_df8c .container');
  if (!container) return; // bail early

  // build the selector list once
  const allTargets = container.querySelectorAll(
    'h0:not(.noanimation), h1:not(.noanimation), h2:not(.noanimation), h3:not(.noanimation), h4:not(.noanimation), h5:not(.noanimation), h6:not(.noanimation), p:not(.noanimation), p2:not(.noanimation)'
  );

  const totalElements = allTargets.length;

  allTargets.forEach((el, index) => {
    el.classList.add('fade-init');

    // headings / text / links also slide up
    if (/^(H[0-6]|P2?|A)$/.test(el.tagName)) el.classList.add('up');

    // Check if the element already has a transition set
    if (!el.style.transitionDelay) {
      // apply delay based on position (first elements load faster, last slower)
      let depth = 0;
      let p = el.parentElement;
      while (p && p !== container) {
        if (p.matches('h0:not(.noanimation), h1:not(.noanimation), h2:not(.noanimation), h3:not(.noanimation), h4:not(.noanimation), h5:not(.noanimation), h6:not(.noanimation), p:not(.noanimation), p2:not(.noanimation)')) {
          depth++;
        }
        p = p.parentElement;
      }
      const delay = (depth > 2 ? (index / totalElements) * 0.7 : 0) + (depth > 2 ? depth * 0.1 : 0);
      el.style.transitionDelay = `${delay}s`;
    }
  });

  /* Intersection Observer for performance‑friendly "in‑view" checks */
  const io = new IntersectionObserver(entries => {
    entries.forEach(({ isIntersecting, target }) => {
      if (isIntersecting) {
        target.classList.add('fade-show');
      } else {
        // Uncomment to re-hide elements if desired:
        // const bounding = target.getBoundingClientRect();
        // if (bounding.top > window.innerHeight || bounding.bottom < 0) {
        //   target.classList.remove('fade-show');
        // }
      }
    });
  }, { rootMargin: '0px 0px 1px 0px' }); // Trigger as soon as top is near bottom of viewport

  allTargets.forEach(el => io.observe(el));
})();

});
